import {GetSeferData} from "SeferPetach/GetData";

export async function getUserMentorsByID(user_data){
    const args = {
        UserId: user_data.MenteeId,
    };
    var payload = await GetSeferData("glusrfm", args);
    return (payload);
}
export async function getLastUserFeedBack(user_data){
    const args = {
        UserId: user_data.MenteeId,
    };
    var payload = await GetSeferData("glufbmmentee", args);
    return (payload);
}
export async function getFeedBackList() {
    var args = {};
    var payload = await GetSeferData("gfbmmenteel", args);
    return (payload);
}
export async function getFeedBackHistoryList(obj) {
    const args = {
        UserId: obj.MenteeId,
    };
    var payload = await GetSeferData("gfbmmenteelhist", args);
    return (payload);
}
export async function getFeedBackByID(obj){
    const args = {
        FeedBackId: obj.FeedBackId,
    };
    var payload = await GetSeferData("gfbmmentee", args);
    return (payload);
}
export async function updateFeedBack(obj) {
    const args = obj;
    var payload = await GetSeferData("ufbmmentee", args);
    return (payload);
}

export async function getFeedBackReport(obj) {
    const args = obj;
    var payload = await GetSeferData("gfbreport", args);
    return (payload);
}
export async function getCycleReportParamList() {
    const args = {};
    var payload = await GetSeferData("gcrp", args);
    return (payload);
}